import {computed} from "vue";

/**
 * Shared tooltip-launching logic for a month cell.
 *
 * - Works for the ATUS-CPS Linking Counts app (counts + topics)
 * - Works for the RoPES (topics only)
 */
export function useMonthTooltip({
                                    year,
                                    month, // 0-based
                                    monthEl, // template ref (HTMLElement)
                                    tooltips_enabled, // Ref<boolean>
                                    tooltip_data,     // Ref<TooltipData>
                                    makeTooltipData,  // function

                                    // optional data suppliers
                                    getLinkingCounts,        // (year, month) => object
                                    getSelectedSampleTopics, // (year, month) => ComputedRef<Array>

                                    // optional positioning knobs
                                    leftOffsetFn = (m) => (m > 8 ? -300 : 100),
                                    bottomOffset = 0
                                }) {
    const linkingCounts = computed(() => {
        return getLinkingCounts?.(year.value, month.value) ?? {};
    });

    const selectedSampleTopics = computed(() => {
        return getSelectedSampleTopics?.(year.value, month.value)?.value ?? [];
    });

    const shouldShowTooltip = computed(() => {
        if (!tooltips_enabled.value) return false;
        return (
            Object.keys(linkingCounts.value).length > 0 ||
            selectedSampleTopics.value.length > 0
        );
    });

    function initTooltip() {
        if (!shouldShowTooltip.value) return;
        if (!monthEl.value) return;

        const containerHeight = window.innerHeight;
        const rect = monthEl.value.getBoundingClientRect();

        tooltip_data.value = makeTooltipData({
            month: month.value,
            year: year.value,
            bottom: containerHeight - rect.bottom + bottomOffset,
            left: rect.left + leftOffsetFn(month.value),

            // put plain data in tooltip_data (not refs/computeds)
            linkingCounts: linkingCounts.value,
            selectedSampleTopics: selectedSampleTopics.value,

            show_tooltip: true
        });
    }

    function teardownTooltip() {
        tooltip_data.value = makeTooltipData({show_tooltip: false});
    }

    const tabindex = computed(() => (shouldShowTooltip.value ? 0 : null));

    return {
        linkingCounts,
        selectedSampleTopics,
        shouldShowTooltip,
        tabindex,
        initTooltip,
        teardownTooltip
    };
}